import { useEffect } from "react";
import InfluencerDashboardSection from "../components/influencerDashboard/InfluencerDashboard";

function InfluencerDashboard() {
  useEffect(() => { document.title = "Discover Creators | Meesha"; }, []);
  return (
    <>
      <InfluencerDashboardSection />
    </>
  );
}

export default InfluencerDashboard;
